
import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import DropDown from '@/common/dropdown.vue';
import BackTop from '@/common/backtop.vue';
import NavMenu from '@/common/navmenu.vue';
import {
  refundType,
  reasonList,
  uploadFile,
  addressList,
  saveAddress,
  applyRefund,
  getDataRefund,
  refundDetail,
  getDataOrder,
  exist_record,
  refundRecord
} from '@/services/http';
import { validateTelPhone } from '@/tools/regexp';
import { readCookie, readStorage } from '@/tools/tools';
import addData from '../../assets/json/address.json';

@Component({
  components: {
    Header,
    Price,
    Footer,
    DropDown,
    BackTop,
    NavMenu
  }
})
export default class extends Vue {
  uploadLoading: boolean = false;

  // 售后申请原因
  reason: string = ''

  options: any[] = []

  whiteStaus: boolean = true // 是否白拿

  cityOptions: any[] = []

  areaOptions: any[] = []

  // 所选原因id
  sort: string = ''

  ruleForm: any = {
    realName: '',
    cityId: '',
    cityName: '',
    areaId: '',
    areaName: '',
    address: '',
    telephone: '',
    defaultAddress: 0,
    provinceId: '',
    provinceName: '',
    addressTemp: ''
  }

  isAddressSelect: boolean = false

  @Action('user/setUserInfoList') setUserInfoList!: Function;

  @State('user') userinfolist: any

  rules: object = {
    realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
    telephone: [
      { required: true, validator: validateTelPhone, trigger: 'blur' }
    ],
    areaId: [
      {
        required: true,
        message: '请选择地址',
        trigger: 'change'
      }
    ],
    addressTemp: [
      { required: true, message: '请输入详细地址', trigger: 'blur' }
    ]
  }

  value: any[] = []

  // 申请原因
  reasonlist: any[] = []

  // 重复提交
  ISSUBMIT: boolean = false

  // 售后申请上限数量
  maxnum: number = 0

  address: string = '请选择'

  showDialogBack: boolean = false

  maxpic: boolean = false // 是否上传到最大数量

  addIndex: number = 0

  // 是否换货
  isreplace: boolean = false

  //  上传图片列表
  fileList: any[] = []

  // 地址列表
  addressList: any = []

  // 所选商品数量
  val: number = 1

  type: number = -1 // 所选类型

  // 换货地址id
  addressid: string = ''

  shoppingList: any[] = []

  // 售后类型列表
  typelist: any = {}

  // 售后类型索引值

  typecurrentindex: number = -1

  issend: boolean = false // 是否发货

  // 上传图片id
  imgids: string = ''

  mobileNo: string = ''

  recordType: number = 0; // 0-无弹窗 1-软件VIP收回 2-优惠券收回 3-软件VIP和优惠券收回

  refundList: any[] = [
    {
      type: 'onlyRefund',
      icon: 'iconhuanhuobeifen',
      title: '仅退款',
      description: '未收到货（包含未签收），或已与卖家协议同意部分退款'
    },
    {
      type: 'returnGoods',
      icon: 'iconhuanhuobeifen1',
      title: '退货退款',
      description: '已收到货，需要退掉收到的商品'
    },
    {
      type: 'exchange',
      icon: 'iconhuanhuo',
      title: '换货',
      description: '已收到货，商品损坏，需要重新换一个'
    }
  ]

  get computedSubmit(): boolean {
    if (this.issend) {
      if (this.type !== 1) {
        return (
          this.reason === ''
          || this.type === 0
          || this.sort === ''
          || this.fileList.length === 0
          || this.mobileNo === ''
        );
      }
      return this.sort === '' || this.reason === '' || this.mobileNo === '';
    }
    return this.type === 0 || this.sort === '' || this.reason === '' || this.mobileNo === '';
  }

  created() {
    this.refundType();
  }

  mounted() {
    this.getUserInfo();
    // this.handData()
  }

  handData() {
    exist_record({ orderNo: this.$route.query.orderNo }).then((res: any) => {
      this.whiteStaus = res.data.data.exchangeOrderShow;
    });
  }

  // VIP会员
  // 优惠券
  // 软件VIP会员和优惠券
  async handApply() {
    if (this.type !== 3) {
      const res: any = await refundRecord({
        orderNo: this.$route.query.orderNo
      });
      if (res.data.code === 100) {
        // 0-无弹窗 1-软件VIP收回 2-优惠券收回 3-软件VIP和优惠券收回
        this.recordType = res.data.data.recordType;
        if (this.recordType !== 0) {
          let tips: string;
          if (this.recordType === 1) {
            tips = '软件VIP';
          } else if (this.recordType === 2) {
            tips = '优惠券';
          } else {
            tips = '软件VIP会员和优惠券';
          }
          this.$confirm(`退款后本单获赠的「<b style="font-weight:bold;color:#333">${tips}</b>」将被收回。是否继续提交退款？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(() => {
            this.applyRefund();
          }).catch(() => {

          });
        } else {
          this.applyRefund();
        }
      }
    } else {
      this.applyRefund();
    }
  }

  // 获取个人信息
  private async getUserInfo() {
    await this.setUserInfoList();

    this.mobileNo = this.userinfolist.userinfolist.phone;
  }

  // 可以申请的售后类型
  private async refundType() {
    // this.shoppingList = readCookie('exchangeList');
    const res: any = await refundType({
      orderDetailId: this.$route.query.id
    });
    this.typelist = res.data.data;
    // this.maxnum = this.shoppingList[0].buyNum - this.typelist.applyingNum;
    this.issend = res.data.data.isSend === 1;
    const response: any = await addressList({
      pageNo: 1,
      pageSize: 20
    });
    this.addressList = response.data.data;
    if (this.typelist.receiveAddress) {
      this.address = `${this.typelist.receiveAddress.realName} ${this.typelist.receiveAddress.telephone} ${this.typelist.receiveAddress.address}`;
      this.addressid = this.typelist.receiveAddress.id;
    } else if (this.addressList.length !== 0) {
      this.address = `${this.addressList[0].realName} ${this.addressList[0].telephone} ${this.addressList[0].address}`;
      this.addressid = this.addressList[0].id;
    }
    this.setApply();
  }

  // 选择售后类型
  private selectType(item: any, index: number) {
    if (this.typelist[item.type] && this.type !== index + 1) {
      this.fileList = [];
      this.maxpic = false;
      this.imgids = '';
      this.type = index + 1;
      this.isreplace = this.type === 3;
      this.sort = '';
      this.typecurrentindex = index;
      this.getReasonList();
    }
  }

  private async setApply() {
    if (this.$route.query.refundId) {
      const res: any = await refundDetail({
        refundId: this.$route.query.refundId
      });
      this.shoppingList = [
        {
          id: res.data.data.mallOrderDetail.id,
          buyNum: res.data.data.mallOrderDetail.buyNum,
          applyNum: res.data.data.mallOrderRefund.applyNum,
          price: res.data.data.mallOrderDetail.price,
          product_name: res.data.data.mallOrderRefund.productName,
          norms: res.data.data.mallOrderRefund.natureList,
          orderNo: res.data.data.mallOrderDetail.orderNo,
          mallImage: res.data.data.mallOrderRefund.productImage.sourceUrl
        }
      ];
      this.val = res.data.data.mallOrderDetail.buyNum;
      this.type = res.data.data.mallOrderRefund.applyType;
      this.typecurrentindex = this.type - 1;
      this.isreplace = this.type === 3;
      this.sort = res.data.data.mallOrderRefund.applyReasonId;
      this.reason = res.data.data.mallOrderRefund.applyReasonDesc;
      this.fileList = res.data.data.mallOrderRefund.applyImage;
      this.maxnum = this.val - this.typelist.applyingNum;
      this.getReasonList();
    } else {
      this.shoppingList = readStorage('exchangeList');
      this.maxnum = this.shoppingList[0].buyNum - this.typelist.applyingNum;
      this.val = this.shoppingList[0].buyNum;
    }
  }

  // 上传图片
  private async uploadpic(event: any) {
    this.uploadLoading = true;
    const file = [...event.target.files];
    const maxlength = this.isreplace ? 9 : 3;
    if (this.fileList.length < maxlength) {
      const uploadlength = maxlength - this.fileList.length;
      const form = new FormData();
      file.forEach((value) => {
        form.append('fileData', value);
        form.append('type', '11');
      });
      const res: any = await uploadFile(form);
      if (res.data.code === 100) {
        this.fileList = [
          ...this.fileList,
          ...res.data.data.slice(0, uploadlength)
        ];
        if (this.fileList.length === maxlength) {
          this.maxpic = true;
        }
        this.imgids = this.fileList.map((e) => e.id).join(',');
      } else {
        (this as any).$message.error(res.data.message);
      }
    }
    this.uploadLoading = false;
  }

  // 删除上传图片
  private removefile(index: number) {
    this.fileList.splice(index, 1);
    this.maxpic = false;
  }

  // 售后申请原因列表
  private async getReasonList() {
    // this.sort = 0;
    const res: any = await reasonList({
      type: this.type
    });
    this.reasonlist = res.data.data;
  }

  // 提交申请售后
  private async applyRefund() {
    if (this.ISSUBMIT) {
      return;
    }
    this.ISSUBMIT = true;
    if (!this.computedSubmit) {
      const anchor = readCookie('anchor');
      const res: any = await applyRefund({
        orderDetailId: this.$route.query.id,
        num: this.val,
        type: this.type,
        applyReasonId: this.sort,
        applyReasonDesc: this.reason,
        applyImageIds: this.imgids,
        exchangeAddressId: this.type === 3 ? this.addressid : '',
        mobileNo: this.mobileNo,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : ''
      });
      if (res.data.code === 100) {
        // eslint-disable-next-line no-unused-vars
        let eventNo;
        if (this.$route.query.from) {
          // eslint-disable-next-line no-nested-ternary
          eventNo = (this.$route.query.sendid === '1' ? '3.1.1.2.1.1.2' : this.type === 1 ? '3.1.1.3.1.1.3' : this.type === 2 ? '3.1.1.3.1.1.1' : '3.1.1.3.1.1.2');
        } else {
          // eslint-disable-next-line no-nested-ternary
          eventNo = (this.$route.query.sendid === '1' ? '3.2.1.3.1.1.2' : this.type === 1 ? '3.2.1.4.1.1.3' : this.type === 2 ? '3.2.1.4.1.1.1' : '3.2.1.4.1.1.2');
        }
        getDataOrder({
          orderNum: '',
          orderStatus: this.$route.query.sendid,
          refundReason: this.sort,
          equip: anchor ? anchor.equip : 4,
          version: anchor ? anchor.version : '',
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          model: anchor ? anchor.model : '',
          equipVersion: anchor ? anchor.equipVersion : '',
          equipMeid: anchor ? anchor.equipMeid : '',
          eventNo,
          companyId: 1
        });
        if (this.$route.query.refundId) {
          await getDataRefund({
            refundingNum: '',
            equip: anchor ? anchor.equip : 4,
            version: anchor ? anchor.version : '',
            src: anchor ? (anchor.src ? anchor.src : 2) : 4,
            model: anchor ? anchor.model : '',
            equipVersion: anchor ? anchor.equipVersion : '',
            equipMeid: anchor ? anchor.equipMeid : '',
            eventNo: '3.2.2.3.1.1.1',
            companyId: 1
          });
        }
        this.$router.push(`/exchange-success?id=${res.data.data.id}`);
      } else {
        this.$message.error(res.data.message);
      }
      setTimeout(() => {
        this.ISSUBMIT = false;
      }, 100);
    }
  }

  // 选择地址
  selectAddress() {
    this.isAddressSelect = !this.isAddressSelect;
  }

  confirmAddress(item: any, index: number) {
    this.address = `${item.realName} ${item.telephone} ${item.address}`;
    this.addressid = item.id;
    this.addIndex = index;
    this.isAddressSelect = false;
  }

  // 新增地址
  openAdd() {
    this.options = addData.data;
    this.value = [];
    this.showDialogBack = true;
    this.$nextTick(() => {
      const form = this.$refs.ruleForm as any;
      form.resetFields();
      this.ruleForm = {
        realName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        address: '',
        area: '',
        telephone: '',
        defaultAddress: 0,
        provinceId: '',
        provinceName: '',
        addressTemp: ''
      };
    });
  }

  // 选择省份
  chooseProvince(id: number) {
    this.ruleForm.provinceName = this.options.filter(
      (e) => e.value === id
    )[0].label;
    this.ruleForm.cityId = this.options.filter(
      (e) => e.value === id
    )[0].children[0].value;
    this.ruleForm.cityName = this.options.filter(
      (e) => e.value === id
    )[0].children[0].label;
    this.cityOptions = this.options.filter((e) => e.value === id)[0].children;
    this.areaOptions = this.cityOptions.filter(
      (e) => e.value === this.ruleForm.cityId
    )[0].children;
    this.ruleForm.areaId = this.cityOptions.filter(
      (e) => e.value === this.ruleForm.cityId
    )[0].children[0].value;
    this.ruleForm.areaName = this.cityOptions.filter(
      (e) => e.value === this.ruleForm.cityId
    )[0].children[0].label;
    this.$nextTick(() => {
      (this as any).$refs.ruleForm.clearValidate('areaId');
    });
  }

  // 选择市
  chooseCity(id: number) {
    this.ruleForm.cityName = this.cityOptions.filter(
      (e) => e.value === id
    )[0].label;
    this.areaOptions = this.cityOptions.filter((e) => e.value === id)[0].children;
    this.ruleForm.areaId = this.cityOptions.filter(
      (e) => e.value === id
    )[0].children[0].value;
    this.ruleForm.areaName = this.cityOptions.filter(
      (e) => e.value === id
    )[0].children[0].label;
    this.$nextTick(() => {
      (this as any).$refs.ruleForm.clearValidate('areaId');
    });
  }

  // 选择区
  chooseArea(id: number) {
    this.ruleForm.areaName = this.areaOptions.filter(
      (e) => e.value === id
    )[0].label;
    this.$nextTick(() => {
      (this as any).$refs.ruleForm.clearValidate('areaId');
    });
  }

  private async addressLists() {
    this.addressList = [];
    const res: any = await addressList({
      pageNo: 1,
      pageSize: 20
    });
    this.addressList = res.data.data;
    if (this.typelist.receiveAddress) {
      if (
        this.addressList.some(
          (e: any) => e.id === this.typelist.receiveAddress.id
        )
      ) {
        this.address = `${this.addressList[1].realName} ${this.addressList[1].telephone} ${this.addressList[1].address}`;
      } else {
        this.address = `${this.addressList[0].realName} ${this.addressList[0].telephone} ${this.addressList[0].address}`;
      }
    } else {
      this.address = `${this.addressList[0].realName} ${this.addressList[0].telephone} ${this.addressList[0].address}`;
    }
    this.isAddressSelect = false;
  }

  private async createData() {
    const form = this.$refs.ruleForm as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.ruleForm.address = this.ruleForm.provinceName
          + this.ruleForm.cityName
          + this.ruleForm.areaName
          + this.ruleForm.addressTemp;
        const res: any = await saveAddress(this.ruleForm);
        if (res.data.code === 100) {
          this.showDialogBack = false;
          this.addressLists();
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.data.message);
        }
      }
    });
  }
}
